import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as vars from "../../constants/constants";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { checkAccess } from "../../actions/WelcomeActions";
import axios from "axios";
import { config } from "../../constants/domainConfig";
import { Row, Col, Modal } from "reactstrap";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { sendData } from "./../../analytics/sendData";
import {
  isValidNumber,
  getPlaceHolder,
  parse,
  getFlag,
} from "./../../utils/loginUtils";
import { getDomainTheme } from "../../constants/theme";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msisdn: "",
      isValid: false,
      errorMessage: "",
      domain: window.location.host,
      msisdnNotFound: false,
      phoneNumerMssg: "",
      invalidNum: "",
      reason: "",
      showDisclaimer: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeMsisdn = this.onChangeMsisdn.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.callAuthenticate = this.callAuthenticate.bind(this);
    this.toggleDisclaimer = this.toggleDisclaimer.bind(this);
  }

  onChangeMsisdn(e) {
    this.setState({ msisdn: e.target.value });
  }

  toggleDisclaimer() {
    this.setState((prev) => ({
      ...prev,
      showDisclaimer: !prev.showDisclaimer,
    }));
  }

  onKeyUp(e) {
    if (e.keyCode == 13) {
      this.onSubmit(e);
    }
  }
  componentDidMount() {
    if (config.lang == "sr") {
      this.setState({
        phoneNumerMssg: "Број телефона је обавезан",
        invalidNum: "Неважећи број телефона.",
        reason: "Претплата није пронађена",
      });
    } else if (config.lang === "lv") {
      this.setState({
        phoneNumerMssg: "Nepieciešams tālruņa numurs.",
        invalidNum: "Nederīgs tālruņa numurs.",
        reason: "Abonements nav atrasts",
      });
    } else if (config.lang === "ee") {
      this.setState({
        phoneNumerMssg: "Telefoninumber on nõutud.",
        invalidNum:
          "Palun kontrolli, kas sisestasid telefoninumbri korrektselt?",
        reason: "Tellimust ei leitud.",
      });
    } else {
      this.setState({
        phoneNumerMssg: "Phone number is required.",
        invalidNum: "Invalid phone Number.",
        reason: "Subscription not found.",
      });
    }
  }
  onSubmit(e) {
    e.preventDefault();
    if (isValidNumber(this.state.msisdn, config.country)) {
      this.setState({ isValid: true, errorMessage: "" });
      const msisdn = parse(this.state.msisdn, config.country);
      this.callAuthenticate({
        msisdn: msisdn,
      });
    } else {
      if (this.state.msisdn === "") {
        this.setState({
          isValid: false,
          msisdnNotFound: false,
          errorMessage: this.state.phoneNumerMssg,
        });
      } else {
        this.setState({
          isValid: false,
          msisdnNotFound: false,
          errorMessage: this.state.invalidNum,
        });
      }
    }
  }

  callAuthenticate(data) {
    this.props.show();
    axios
      .get(
        vars.BASE_API_URL +
          `/checkAccessWithMsisdn?msisdn=${data.msisdn}&domain=${
            window.location.hostname.includes("localhost")
              ? "ae.mobiofit.com"
              : window.location.hostname
          }`,
      )
      .then((response) => {
        this.props.hide();
        if (response.data.success) {
          let data = {
            success: response.data.success,
            uid: response.data.data.uid,
            token: response.data.data.token,
            rockmanId: response.data.data.rockmanId,
          };
          sessionStorage.setItem("authorized", JSON.stringify(data));
          this.props.checkAccess(data);
          sendData(data.rockmanId, "", "", "Accessed", {
            method: "msisdn",
            status: "success",
            url: window.location.href,
          });
          let to = `/home?uid=${data.uid}`;
          this.props.history.push(to);
        } else {
          this.setState({
            msisdnNotFound: true,
            reason: this.state.reason,
          });
          // this.props.history.push("/restricted");
        }
      })
      .catch((error) => {
        this.props.hide();
        console.log(error);
        this.props.history.push("/restricted");
      });
  }

  render() {
    const theme = getDomainTheme();
    const flag_url = getFlag(config.country);
    //if(!this.state.msisdnNotFound){
    return (
      <div className="login animated fadeIn">
        <Row className="justify-content-center">
          <Col>
            <Row className="login-page-header">
              <div className="login-page-header-child">
                <img
                  className={
                    config.newDomain === "fitness-bay" ||
                    config.newDomain == "fun-box"
                      ? "login-page-logo-alt"
                      : "login-page-logo"
                  }
                  src={theme.logo}
                  alt={theme.productName}
                />
              </div>
            </Row>

            {config.subDomain == "es" ? (
              <Row className="login-page-content">
                <h1>Eres miembro de MobioTV?</h1>
                <p>
                  Por favor confirma tu número de móvil y recibe contenido
                  ilimitado para todos nuestros servicios.
                </p>
                <div className="login-page-mobile_num">
                  <input
                    autoFocus
                    type="number"
                    name="msisdn"
                    maxLength="15"
                    value={this.state.msisdn}
                    onChange={this.onChangeMsisdn}
                    onKeyUp={this.onKeyUp}
                    className="LoginRoute-number"
                  />
                  <button
                    type="submit"
                    onClick={this.onSubmit}
                    className="LoginRoute-button"
                  >
                    Acceso
                    <i className="icon-back"></i>
                  </button>
                </div>
              </Row>
            ) : (
              <Row className="login-page-content">
                <h1>
                  {
                    <FormattedMessage
                      id={`areYou_${theme.productName}`}
                      defaultMessage={`Are you already a member of ${theme.productName}?`}
                    />
                  }
                </h1>
                <p>
                  <FormattedHTMLMessage
                    id="thenConfirm"
                    defaultMessage="Then confirm your mobile number and get unlimited access to all our <strong> TV </strong> and <strong> Video </strong> content"
                  />
                </p>
                {config.subDomain === "lv" && (
                  <div
                    className="login-page-disclaimer"
                    onClick={this.toggleDisclaimer}
                  >
                    Lietošanas noteikumi un atbalsts
                  </div>
                )}
                {config.subDomain === "lv" && (
                  <Modal
                    wrapClassName="modal-wrap-disclaimer"
                    isOpen={this.state.showDisclaimer}
                    toggle={this.toggleDisclaimer}
                    className="disclaimer-modal"
                    contentClassName="disclaimer-modal-content"
                  >
                    <p>
                      Šis ir MobioTV straumēšanas pakalpojums, ko nodrošina Sam
                      Media BV. Katru nedēļu no jums tiks iekasēti 3,50 eiro, un
                      jūsu abonements tiks automātiski atjaunots. Šīs izmaksas
                      būs jāmaksā no jūsu priekšapmaksas atlikuma abonēšanas
                      sākumā un pēc tam katru nedēļu, vai arī tās tiks
                      pievienotas ikmēneša mobilā telefona rēķinam par šo
                      tālruni. Īsziņas sūtīšanas maksa tiek piemērota mobilā
                      operatora standarta tarifiem. Pakalpojuma abonementu var
                      atcelt, nosūtot īsziņu STOP MOBIO uz 82020. Mobilo datu
                      izmantošanas izmaksas var tikt piemērotas atbilstoši jūsu
                      tarifa plānam. Lai pievienotos pakalpojumam, jums jābūt
                      vismaz 18 gadus vecam. Reģistrējoties un/vai izmantojot
                      pakalpojumu, jūs piekrītat un apstiprināt, ka esat
                      izlasījis Noteikumus un nosacījumus un Privātuma politiku,
                      ka esat vecumā virs 18 gadiem un esat mobilā konta
                      īpašnieks vai jums ir mobilā konta turētāja piekrišana. Ja
                      jums ir kādi jautājumi, varat sazināties ar klientu
                      atbalsta dienestu pa tālruni +37167151240 vai pa e-pastu:
                      lv@mobiotv.com. Šo pakalpojumu nodrošina Sam Media, Van
                      Diemenstraat 140, 1013CN - Amsterdama, Nīderlande
                    </p>
                    <br />
                    <div>
                      <a
                        href="http://c1.ouisys.com/static/terms-mobiotv-lv"
                        target="_new"
                      >
                        Noteikumi un Nosacījumi
                      </a>{" "}
                      -{" "}
                      <a
                        href="http://c1.ouisys.com/static/privacy-sammedia-lv"
                        target="_new"
                      >
                        Privātuma Politika
                      </a>
                    </div>
                  </Modal>
                )}
                <div className="login-page-mobile_num">
                  {flag_url ? (
                    <div className="flag">
                      <img
                        src={flag_url}
                        className={`flag_url ${
                          config.lang === "ar" ? "flag_url_ar" : ""
                        }`}
                      />
                    </div>
                  ) : null}
                  <input
                    placeholder={getPlaceHolder(config.country)}
                    type="number"
                    autoFocus
                    name="msisdn"
                    maxLength="15"
                    value={this.state.msisdn}
                    onChange={this.onChangeMsisdn}
                    onKeyUp={this.onKeyUp}
                    className="LoginRoute-number"
                    style={flag_url ? { textIndent: "41px" } : {}}
                  />
                  <button
                    type="submit"
                    onClick={this.onSubmit}
                    className={
                      config.useMobiofitTheme
                        ? "LoginRoute-button LoginRoute-button-mobiofit"
                        : "LoginRoute-button"
                    }
                  >
                    <FormattedMessage id="login" defaultMessage="Login" />
                    <i className="icon-back"></i>
                  </button>
                  {this.state.msisdnNotFound ? (
                    <span>{this.state.reason}</span>
                  ) : !this.state.isValid ? (
                    <span>{this.state.errorMessage}</span>
                  ) : null}
                </div>
              </Row>
            )}
          </Col>
        </Row>
      </div>
    );
    //}
    // else return (<MsisdnNotFound reason={this.state.reason} />)
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer,
    access: state.WelcomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // authenticate,
      checkAccess,
      show,
      hide,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js